import React from "react";
import { Database, ListTree, Send, Users, Zap } from "lucide-react";
import TabPageLayout from "modules/swiftboard/components/TabPageLayout";
import useUrlTab from "modules/swiftboard/components/useUrlTab";
import NoDataState from "modules/swiftboard/components/NoDataState";
import Source from "./source/Source";
import SourceField from "./source-field/SourceField";
import Channel from "./channel/Channel";
import RecipientType from "./recipient-type/RecipientType";
import DomainEvent from "./domain-event/DomainEvent";

// The page of each tab, by slug. A tab without one shows a placeholder.
const TAB_PAGES = {
  source: Source,
  "source-field": SourceField,
  channel: Channel,
  "recipient-type": RecipientType,
  "domain-event": DomainEvent,
};

// Registries the reminder builder reads from (tbl_rem_source, tbl_rem_source_field,
// tbl_rem_channel, tbl_rem_recipient_type, tbl_rem_domain_event).
// `slug` is the ?tab= value: keep it stable even if the label changes.
const REMINDER_SETUP_TABS = [
  {
    id: 1,
    slug: "source",
    label: "Source",
    Icon: Database,
    description: "Tables exposed to the reminder builder, grouped by module.",
  },
  {
    id: 2,
    slug: "source-field",
    label: "Source Field",
    Icon: ListTree,
    description: "Whitelisted fields of a source that conditions, templates and recipient pickers can use.",
  },
  {
    id: 3,
    slug: "channel",
    label: "Channel",
    Icon: Send,
    description: "Delivery channels a reminder can be sent through, such as Email and In-App.",
  },
  {
    id: 4,
    slug: "recipient-type",
    label: "Recipient Type",
    Icon: Users,
    description: "Who can receive a reminder, such as the subject user, assigned admin or a role.",
  },
  {
    id: 5,
    slug: "domain-event",
    label: "Domain Event",
    Icon: Zap,
    description: "Events emitted from code that can trigger a reminder, such as a project status change.",
  },
];

const ReminderSetup = () => {
  const [activeTab, setActiveTab] = useUrlTab(REMINDER_SETUP_TABS.map((tab) => tab.slug));

  const tabs = REMINDER_SETUP_TABS.map(({ id, label, Icon }) => ({ id, label, icon: <Icon size={18} /> }));
  const current = REMINDER_SETUP_TABS[activeTab];
  const TabPage = TAB_PAGES[current.slug];

  return (
    <TabPageLayout tabs={tabs} activeTab={activeTab} onTabChange={(index) => setActiveTab(index)}>
      {TabPage ? (
        <TabPage key={current.slug} />
      ) : (
        <div className="h-full bg-surface border border-border rounded-lg shadow-sm">
          <NoDataState
            key={current.slug}
            icon={current.Icon}
            title={`No ${current.label} records yet`}
            message={current.description}
            showBack={false}
            showRefresh={false}
          />
        </div>
      )}
    </TabPageLayout>
  );
};

export default ReminderSetup;
